import "../../assets/stylesheets/module-participation.scss"
import "./modules/init.js";
// init.js must be first
import "./modules/application.js";
import "./modules/contribution_containers_controller.js";
import "./modules/poll_teaser_controller.js";
import "./modules/processes_controller.js";
import "./modules/process_polls_controller.js";
import { checkAndReportAccessibility } from 'lib/shared'

document.addEventListener('DOMContentLoaded', () => {

  if (process.env.NODE_ENV === 'development') {
    checkAndReportAccessibility()
  }

});
